import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'jobenviodadossoaplib'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/jobenviodadossoaplib`

class JobEnviaDadosWsSoap {
  about () {
    return Api().get(`${clientRoot()}/about`)
  }

  insert (item) {
    return Api().post(root, item)
  }

  update (item) {
    return Api().put(root, item)
  }

  findAll () {
    return Api().get(`${clientRoot()}`)
  }

  delete ({ jobIdentifier }) {
    return Api().delete(`${clientRoot()}/${jobIdentifier}`)
  }

  findById (id) {
    return Api().get(`${clientRoot()}/${id}`)
  }

  play (id) {
    return Api().post(`${clientRoot()}/play/${id}`)
  }
}

export default new JobEnviaDadosWsSoap()
